import { isSameRow } from '@zoryn/components/grid/src/utils/is-same-row'
import { syncCurrentRowDom } from '@zoryn/components/grid/src/utils/sync-current-row-dom'
import type { DataGridTree } from '../types'

export function useRow($grid: DataGridTree) {
  $grid.setCurrentRow = (row) => {
    const prevRow = $grid.reactData.currentRow
    if (isSameRow(prevRow, row)) {
      return
    }
    syncCurrentRowDom($grid as never, prevRow, row)
    $grid.reactData.currentRow = row
  }

  $grid.syncCurrentRowDom = () => {
    const current = $grid.reactData.currentRow
    syncCurrentRowDom($grid as never, null, current)
  }
}
